import { render, staticRenderFns } from "./normalcharts.vue?vue&type=template&id=9f69fd66&"
import script from "./normalcharts.vue?vue&type=script&lang=js&"
export * from "./normalcharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports